import React, { useState } from 'react';
import { CreateForm } from 'framework/form';
import { Modal } from 'framework/ui/ui-builder';
import { OneStopModalDecorator } from 'domain/shared/oneStop';
import InstantFeedbackForm from './createupdate/InstantFeedbackForm';
import InstantFeedbackLayout from './InstantFeedbackRequestLayout';
import useInstantFeedbackService from './InstantFeedbackService';
import { Typography } from '@mui/material';

const MESSAGE_CONTEXT = 'feedbackForm';

type FeedbackFormProps = {
  closeFeedbackForm: () => void;
};

const InstantFeedbackModalForm = ({ closeFeedbackForm }: FeedbackFormProps) => {
  const [isModalOpen, setIsModalOpen] = useState(true);
  const { create, getValidationSchema } = useInstantFeedbackService();

  const closeFeedbackModal = () => setIsModalOpen(false);

  const title = (
    <Typography variant="h3" mb={2.5}>
      Feedback about colleague
    </Typography>
  );

  return (
    <OneStopModalDecorator
      isOneStop={false}
      submitHandler={closeFeedbackModal}
      handleMessageModalClose={closeFeedbackForm}
      messageContext={MESSAGE_CONTEXT}
    >
      <CreateForm
        submitFormFunc={create}
        messageContext={MESSAGE_CONTEXT}
        getValidationSchemaFunc={getValidationSchema}
        initialData={{
          isSharedWithEmployee: false,
        }}
      >
        <Modal
          data-testid="instant-feedback-form"
          key="modal-not-strict"
          modalSize="sm"
          backdrop="static"
          keyboard={false}
          isOpen={isModalOpen}
          hasCancelButton={false}
          title={null}
          onToggle={closeFeedbackForm}
        >
          <InstantFeedbackLayout handleCancelClick={closeFeedbackForm} headerRight={title} isFixedButtons={false}>
            <InstantFeedbackForm />
          </InstantFeedbackLayout>
        </Modal>
      </CreateForm>
    </OneStopModalDecorator>
  );
};

export default InstantFeedbackModalForm;
